$ = require 'jquery'
h = require './helpers'

class Bonuses

  applyStyles: ->
    console.log 'Применяю стили Bonuses'
    $form = $('#aspnetForm')

#    $('body').removeClass().addClass('bonuses')

    if $('.bonuses-content').length == 0
      h.h1('Бонусная программа', 'h1-bonuses').appendTo $form
      [$row, $wrapper] = h.rowN(true, 'bonuses-content')
      $form.append $row

      $iframe = $ '<iframe/>',
        src: '//www.tourtrans.ru/pages/for-agencies/bon-prog2015.html?iframe=1'
      $wrapper.append $iframe

      h.h1('Начисленные баллы', 'h1-points').appendTo $form
      [$row, $wrapper] = h.rowN(true, 'points-content')
      $row.appendTo $form
      $wrapper.append($('#ctl00_generalContent_TabContainer1_TabPanel2_bonusList_AgencyBonusesGrid'))

      $('#ctl00_generalContent_TabContainer1_TabPanel2_bonusList_AgencyBonusesGrid th:nth-child(5)').text('Активные баллы')

module.exports = new Bonuses